import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { uploadAndCreateImageEntry } from "../../../utils/createImgforLots";
import mainAxios from "../../../redux/api/mainAxios";
import { imageLoader } from "../../../utils/imageLoader";
import { refetchCity } from "../../../redux/actions/citiesActions";
import { useDispatch } from "react-redux";
import "./city.css";
import { closeModal } from "../../../redux/actions/modalActions";

const UpdateCity = ({ city }) => {
  const dispatch = useDispatch();
  const [selectedImages, setSelectedImages] = useState([]);
  const [uploadedImageEntries, setUploadedImageEntries] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [imagesToShow, setImagesToShow] = useState(city.images);

  useEffect(() => {
    setImagesToShow(city.images);
  }, [city.images.length]);

  const handleImageSelect = (e) => {
    const files = Array.from(e.target.files);
    setSelectedImages((prev) => [...prev, ...files]);
  };
  const removeImage = (index) => {
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleDeleteImage = async (imageId) => {
    try {
      await mainAxios.delete(`/api/images/${imageId}`);
      setImagesToShow((prev) =>
        prev.filter((image) => image.documentId !== imageId)
      );
      dispatch(refetchCity(city.documentId));
    } catch (error) {
      console.error("Error deleting image:", error);
    }
  };

  const handleImageUpload = async () => {
    setUploading(true);
    const uploadedEntries = [];

    try {
      // Process each selected image
      for (const file of selectedImages) {
        const reference = `temp-${Date.now()}`;
        const entry = await uploadAndCreateImageEntry(file, reference);
        if (entry) {
          uploadedEntries.push(entry);
        }
      }

      setUploadedImageEntries(uploadedEntries);
      toast.success(
        `${uploadedEntries.length} image(s) téléchargé(s) avec succès`
      );
      return uploadedEntries;
    } catch (error) {
      console.error("Error uploading images:", error);
      toast.error("Failed to upload one or more images");
      return [];
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = async () => {
    let imageEntries = uploadedImageEntries;
    if (selectedImages.length > 0 && uploadedImageEntries.length === 0) {
      imageEntries = await handleImageUpload();
    }

    await mainAxios.put(`/api/cities/${city.documentId}`, {
      data: {
        images: [
          ...imageEntries.map((entry) => entry.id),
          ...city.images.map((image) => image.id),
        ],
      },
    });
    dispatch(refetchCity(city.documentId));
    dispatch(closeModal());
    setUploading(false);
  };

  return (
    <div style={{ maxWidth: "700px", overflow: "hidden" }}>
      <div
        className="hideScrollbar d-flex gap-4 py-4"
        style={{ maxWidth: "100%", overflow: "scroll" }}
      >
        {imagesToShow.map((image) => (
          <div
            key={image.id}
            className="position-relative border d-flex align-items-center radius5"
          >
            <button
              type="button"
              className="remove-image-btn position-absolute top-0 end-0 btn btn-sm text-danger bold"
              onClick={() => handleDeleteImage(image.documentId)}
              aria-label="Supprimer cette image"
            >
              ✕
            </button>

            <img
              key={image.id}
              src={imageLoader(image.image[0].url)}
              alt={image.name}
              width={200}
              height={"auto"}
              style={{ objectFit: "contain" }}
            />
          </div>
        ))}
      </div>
      <div className="form-group d-flex flex-column">
        <label className="my-4">Images</label>

        {/* Custom French button that triggers the hidden input */}
        <button
          type="button"
          className=" radius5 px-20 py-10 bg-pink text-white border-0 hoverOpacity"
          onClick={() => document.getElementById("image-input").click()}
        >
          Sélectionner des images
        </button>

        {/* Hidden actual file input */}
        <input
          id="image-input"
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageSelect}
          className="d-none"
        />

        {selectedImages.length > 0 && (
          <div className="selected-images d-flex flex-column gap10 mt-2">
            <p className="fw-bold mb-2">
              Images sélectionnées ({selectedImages.length}):
            </p>
            <div
              className="image-previews d-flex gap-4 py-3 hideScrollbar"
              style={{ maxWidth: "100%", overflow: "scroll" }}
            >
              {selectedImages.map((file, index) => (
                <div
                  key={index}
                  className="image-preview-item position-relative p-2 border rounded bg-light"
                >
                  <p className="lot-image-name mb-0">{file.name}</p>
                  <button
                    type="button"
                    className="remove-image-btn position-absolute top-0 end-0 btn btn-sm text-danger"
                    onClick={() => removeImage(index)}
                    aria-label="Supprimer cette image"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>

            {uploadedImageEntries.length > 0 && (
              <div className="upload-success mt-2" s>
                <p className="text-success">
                  {uploadedImageEntries.length} image(s) téléchargée(s) avec
                  succès
                </p>
              </div>
            )}

            <button
              disabled={uploading}
              onClick={handleSubmit}
              className={`radius5 px-20 py-10 text-white border-0 hoverOpacity ${
                uploading ? "bg-soft-grey" : "bg-pink"
              }`}
            >
              {uploading ? "En cours..." : "Ajouter les medias"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpdateCity;
